import React, { useState, useEffect, useCallback } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationDrawer from './NotificationDrawer';
import notificationService from '../services/notificationService';

const POLL_MS = 30000;

const NotificationBell = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const fetchCount = useCallback(async () => {
    try {
      const res = await notificationService.getUnreadCount();
      setUnreadCount(res.data?.count ?? 0);
    } catch {
      // ignore polling errors silently
    }
  }, []);

  useEffect(() => {
    fetchCount();
    const id = setInterval(fetchCount, POLL_MS);
    return () => clearInterval(id);
  }, [fetchCount]);

  const handleOpen = () => setDrawerOpen(true);

  const handleClose = () => {
    setDrawerOpen(false);
    fetchCount();
  };

  return (
    <>
      <Tooltip title="Notifications">
        <IconButton color="inherit" onClick={handleOpen} size="large">
          <Badge badgeContent={unreadCount} color="error" max={99}>
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <NotificationDrawer open={drawerOpen} onClose={handleClose} />
    </>
  );
};

export default NotificationBell;
